
import { supabase } from '@/integrations/supabase/client';
import { Poll } from '@/types/poll';

/**
 * Hook for fetching updated poll data after voting
 */
export const usePollUpdater = () => {
  /**
   * Fetch updated poll data from the database
   * @param pollId The ID of the poll to update
   * @returns The updated poll data, or null if an error occurred
   */
  const fetchUpdatedPoll = async (pollId: string): Promise<Partial<Poll> | null> => {
    try {
      console.log('Fetching updated poll data...');
      
      const { data: updatedPollData, error: fetchError } = await supabase
        .from('polls')
        .select('*')
        .eq('id', pollId)
        .single();
      
      if (fetchError) {
        console.error('Error fetching updated poll:', fetchError);
        return null;
      }
      
      if (!updatedPollData) {
        console.error('No updated poll data found');
        return null;
      }
      
      console.log('Received updated poll data:', updatedPollData);
      
      // Extract and return the relevant data
      const questionsData = updatedPollData.questions as { 
        options: any[],
        total_votes: number,
        category: string,
        linked_card_id: string | null
      };
      
      return {
        options: questionsData.options || [],
        total_votes: questionsData.total_votes || 0,
        category: questionsData.category || '',
        linked_card_id: questionsData.linked_card_id || null
      };
    } catch (error) {
      console.error('Error in fetchUpdatedPoll:', error);
      return null;
    }
  };

  return {
    fetchUpdatedPoll
  };
};
